import { render } from "./Trash.vue?vue&type=template&id=57e8fbba&scoped=true"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import "./Trash.vue?vue&type=style&index=0&id=57e8fbba&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e8fbba"]])

export default __exports__